const StyleVariables = {
  // Legacy colors
  colorGrey: 'rgba(0,0,0,0.4)',
  colorWhite: '#FFFFFF',
  colorGreen: '#00FF00',
  optiosBlue: '#428BE3',
  availableColor: 'rgba(105,211,33,0.5)',
  busyColor: 'rgba(251,176,59,0.5)',
  fullColor: 'rgba(210,68,68,0.5)',

  // Neutral colors
  colorBlack: '#000',

  // Border radius
  borderRadiusCard: '8px',
  borderRadiusPill: '64px',
  borderRadiusRounded: '20px',

  // Spacing
  cardPadding: '24px 30px',
  cardMargin: '0 20px 16px 20px',
  cardMaxWidth: '380px',
  horizontalGutter: '20px',

  // Typography
  fontSizeBase: '16px',
}

interface ICalendarColors {
  availableColor: string
  busyColor: string
  fullColor: string
}

export interface ICalendarStyle extends ICalendarColors {
  markerRadius: number
}

export default StyleVariables
